import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, ref } from 'vue';
import { Field, DropdownField } from '@samc/centricity-core';
import { PriceModelSource } from '@/Sources';
import { IPriceModel } from '../../Interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceModelDropdownField',
  props: {
    value: { type: null, required: false },
    label: { type: String, required: false, default: 'Price Model' },
    errorText: { type: String, required: false, default: '' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false, default: '' },
    required: { type: Boolean, required: false, default: false },
    valueField: { type: String, required: false },
    searchable: { type: Boolean, required: false, default: true },
    debounceMs: { type: Number, required: false, default: 500 },
    clearable: { type: Boolean, required: false, default: true }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({ (event: 'input', value: IPriceModel | null): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: IPriceModel | null, label: string, errorText: string, disabled: boolean, autoAssign: boolean, placeholder: string, required: boolean, valueField?: string, searchable: boolean, debounceMs: number, clearable: boolean };





/** Same pattern as TaskTemplateDropdownField: ref() so Vue tracks the CachedDataSource instance. */
const source = ref(new PriceModelSource());

const val = computed({
  get: () => props.value ?? null,
  set: (next: IPriceModel | null) => {
    emit('input', next);
  }
});

async function reloadSource(): Promise<void> {
  source.value = await PriceModelSource.createLoaded();
}

expose({
  reloadSource
});

return { __sfc: true,props, emit, source, val, reloadSource, Field, DropdownField }
}

})